(function () {
  'use strict';

  var nav         = document.getElementById('pnb');
  var sentinel    = document.getElementById('pnb-sentinel');
  var placeholder = document.getElementById('pnb-placeholder');

  if (!nav || !sentinel || !placeholder) return;

  var headerHeight = parseInt(nav.dataset.headerHeight, 10) || 0;
  var isSticky     = false;
  var ticking      = false;
  var targets      = [];
  var curActive    = null;

  function getOffsetTop(el) {
    var top = 0;
    while (el) { top += (el.offsetTop || 0); el = el.offsetParent; }
    return top;
  }

  function makeSticky() {
    if (isSticky) return;
    isSticky = true;
    placeholder.style.height  = nav.offsetHeight + 'px';
    placeholder.style.display = 'block';
    nav.classList.add('is-sticky');
  }

  function makeNormal() {
    if (!isSticky) return;
    isSticky = false;
    placeholder.style.display = 'none';
    nav.classList.remove('is-sticky');
  }

  function updateActive(scrollY) {
    if (!targets.length) return;
    var navH   = isSticky ? (nav.offsetHeight || 0) : 0;
    var offset = headerHeight + navH + 24;
    var cur    = targets[0];
    for (var i = targets.length - 1; i >= 0; i--) {
      if (scrollY >= getOffsetTop(targets[i].el) - offset) {
        cur = targets[i];
        break;
      }
    }
    if (cur && cur.link !== curActive) setActive(cur.link);
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        var scrollY   = window.scrollY || window.pageYOffset;
        var threshold = getOffsetTop(sentinel) - headerHeight;
        if (scrollY >= threshold) makeSticky();
        else makeNormal();
        updateActive(scrollY);
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    makeNormal();
    setTimeout(onScroll, 50);
  }, { passive: true });

  function setActive(link) {
    if (curActive === link) return;
    if (curActive) curActive.classList.remove('is-active');
    curActive = link;
    if (!curActive) return;
    curActive.classList.add('is-active');
    var inner = nav.querySelector('.pnb__inner');
    if (inner) {
      var sl = link.offsetLeft - inner.offsetWidth / 2 + link.offsetWidth / 2;
      inner.scrollTo({ left: sl, behavior: 'smooth' });
    }
  }

  nav.addEventListener('click', function (e) {
    var link = e.target.closest('.pnb__link');
    if (!link) return;
    var anchor = link.getAttribute('data-anchor');
    if (!anchor) return;
    var target = document.querySelector(anchor);
    if (!target) return;
    e.preventDefault();
    var navH = isSticky ? nav.offsetHeight : 0;
    var top  = getOffsetTop(target) - headerHeight - navH - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    setActive(link);
  });

  function init() {
    nav.querySelectorAll('.pnb__link').forEach(function (link) {
      var anchor  = link.getAttribute('data-anchor');
      if (!anchor) return;
      var section = document.querySelector(anchor);
      if (section) targets.push({ el: section, link: link });
    });
    if (targets.length) setActive(targets[0].link);
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
